var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserAepsBalance(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15.231,
    height: 20.411,
    viewBox: "0 0 15.231 20.411",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_532",
    "data-name": "Rectangle 532",
    width: 15.231,
    height: 20.411,
    fill: "#00baf2"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_241",
    "data-name": "Group 241",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_240",
    "data-name": "Group 240",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_357",
    "data-name": "Path 357",
    d: "M14.865,16.109c4.523,0,7.284,2.427,8.047,6.407a9.876,9.876,0,0,1,.174,2.935c-.037.338-.057.718-.516.679s-.428-.433-.418-.761a10.918,10.918,0,0,0-.5-3.762,5.93,5.93,0,0,0-4.559-4.289c-.326-.071-.852-.289-.958.151-.1.395.439.439.766.524a5.723,5.723,0,0,1,4.582,5.35,8.325,8.325,0,0,1-.24,3.165,6.964,6.964,0,0,0-.319,1.481,4.012,4.012,0,0,1-1.333,2.568.512.512,0,0,1-.767.071.479.479,0,0,1-.022-.717,7.4,7.4,0,0,0,1.371-2.656,12.314,12.314,0,0,0,.375-2.566,7.859,7.859,0,0,0-.172-2.017,4.788,4.788,0,0,0-4.69-3.805A5.842,5.842,0,0,0,10.251,21.5c-.084.116-.165.236-.256.346A.442.442,0,0,1,9.4,22a.43.43,0,0,1-.138-.643,5.983,5.983,0,0,1,1.409-1.774,6.9,6.9,0,0,1,4.487-1.76c.263,0,.6.024.558-.377-.039-.362-.338-.252-.582-.238A11.206,11.206,0,0,0,10.1,18.893a4.8,4.8,0,0,1-.432.233.421.421,0,0,1-.55-.13.455.455,0,0,1,.023-.619,1.172,1.172,0,0,1,.276-.241,11.949,11.949,0,0,1,5.445-2.027",
    transform: "translate(-7.9 -14.125)",
    fill: "#00baf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_358",
    "data-name": "Path 358",
    d: "M33.818,66.141c-.472,0-.944-.006-1.415,0-.655.01-.81.192-.859.983-.031.5.256.827.833.842,1.025.027,2.051.01,3.076.017.7,0,.745.078.537.755a1.351,1.351,0,0,1-1.222,1.052,10.568,10.568,0,0,1-3.183-.122,2.1,2.1,0,0,1-1.822-2.336,12.5,12.5,0,0,1,1.069-4.52,3.891,3.891,0,0,1,4.8-1.826,2.427,2.427,0,0,1,1.519,2.893,6.806,6.806,0,0,1-.222.957,1.566,1.566,0,0,1-1.638,1.293c-.491.023-.984,0-1.476,0v.006M33.7,64.3V64.3c.306,0,.611,0,.917,0s.613.037.71-.392a.991.991,0,0,0-.315-1.153A2.011,2.011,0,0,0,32.239,63.9c-.048.271.031.391.3.393.387,0,.774,0,1.162,0",
    transform: "translate(-26.088 -53.301)",
    fill: "#00baf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_359",
    "data-name": "Path 359",
    d: "M6.849,101.141a5.477,5.477,0,0,0,3.382-1.015c.084-.058.172-.112.26-.164.255-.152.517-.193.712.073.229.312.036.54-.21.724a6.8,6.8,0,0,1-3.323,1.351A6.847,6.847,0,0,1,1.824,100.3C-.044,98.477-.328,96.2.3,93.751c.076-.293.225-.566.592-.488s.384.4.339.69a8.385,8.385,0,0,0-.2,2.623,5.336,5.336,0,0,0,5.285,4.565c.143,0,.287,0,.527,0",
    transform: "translate(0 -81.764)",
    fill: "#00baf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_360",
    "data-name": "Path 360",
    d: "M22.351,48.627a.681.681,0,0,1-.292-.9,5.271,5.271,0,0,1,7.256-2.883,4.457,4.457,0,0,1,2.263,3,1.132,1.132,0,0,1,.029.3c0,.308-.064.6-.421.65s-.521-.221-.563-.52a3.751,3.751,0,0,0-.876-1.8,2.451,2.451,0,0,0-1.53-.953c-2.188-.38-4.007.081-5.114,2.361-.162.335-.326.673-.753.739Z",
    transform: "translate(-19.283 -38.861)",
    fill: "#00baf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_361",
    "data-name": "Path 361",
    d: "M22.192,0a11.709,11.709,0,0,1,6.9,2.141c.309.212.662.46.355.889-.279.39-.623.177-.918-.023a11.385,11.385,0,0,0-2.608-1.362,9.664,9.664,0,0,0-6.912.08c-.076.03-.154.056-.231.085-.3.115-.586.1-.735-.222-.169-.368.066-.591.37-.721A10.753,10.753,0,0,1,19.686.4,9.324,9.324,0,0,1,22.192,0",
    transform: "translate(-15.775 0)",
    fill: "#00baf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_362",
    "data-name": "Path 362",
    d: "M15.416,79.276a.763.763,0,0,1,.32.9,16.874,16.874,0,0,0-.565,3.2,3.459,3.459,0,0,0,3.135,3.744c.1.017.2.02.3.039.331.06.615.2.571.589s-.343.485-.683.452a4.537,4.537,0,0,1-4.329-3.765c-.3-1.634.254-3.158.595-4.708a.6.6,0,0,1,.652-.452h0",
    transform: "translate(-12.35 -69.511)",
    fill: "#00baf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    "data-name": "Path 363",
    d: "M2.7,66.731a3.905,3.905,0,0,1,.425-1.487c.161-.294.4-.5.748-.325s.341.473.184.784a2.912,2.912,0,0,0-.339,1.163c-.019.345-.128.691-.548.672-.481-.022-.472-.418-.471-.806",
    transform: "translate(-2.364 -56.867)",
    fill: "#00baf2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    d: "M61.861,140.472c-.426-.009-.823-.028-.849-.491s.351-.537.726-.546a3.455,3.455,0,0,0,1.126-.284c.307-.114.632-.155.794.207s-.084.576-.386.715a4.137,4.137,0,0,1-1.41.4",
    transform: "translate(-53.495 -121.941)",
    fill: "#00baf2"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAepsBalance);
export default __webpack_public_path__ + "static/media/userAepsBalance.8ba48c9af85f62753e19149f0b95690d.svg";
export { ForwardRef as ReactComponent };